<template>

</template>

<script>
export default {
    name: 'Toolbar',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue